/**
 * 判断采集的媒体类型
 */

/**
 * 判断采集是否为视频素材（基于素材分类）
 * @param pin 采集对象
 * @returns 如果是视频素材返回true，否则返回false
 */
export const isVideo = (pin?: IPin): boolean => {
  if (!pin) {
    return false;
  }

  return (
    pin?.file_material?.material_category === "视频模板" ||
    pin?.file_material?.material_category === "视频"
  );
};

/**
 * 判断采集是否为GIF素材（基于文件类型）
 * @param pin 采集对象
 * @returns 如果是GIF素材返回true，否则返回false
 */
export const isGif = (pin?: IPin): boolean => {
  if (!pin) {
    return false;
  }

  return pin?.file?.type === "image/gif";
};

/**
 * 判断采集是否为字体素材
 * @param pin 采集对象
 * @returns 如果是字体素材返回true，否则返回false
 */
export const isFont = (pin?: IPin): boolean => {
  if (!pin) {
    return false;
  }

  return pin?.file_material?.material_category === "字体";
};

/**
 * 判断采集是否为视频或GIF素材
 * @param pin 采集对象
 * @returns 如果是视频或GIF素材返回true，否则返回false
 */
export const isVideoOrGif = (pin?: IPin): boolean => {
  return isVideo(pin) || isGif(pin);
};
